import { BackgroundFillByStatus } from './BackgroundFillByStatus';

export default BackgroundFillByStatus;
